// For now, it's used in Vista Orders export filters
// Model Year core
export function modelYearCore() {
  const endpoint = '/vistaorder/modelyear';

  return {
    endpoint
  };
}

// Year filter
export function modelYearFilter() {
  const parameter = 'ModelYear';

  // Get rows
  const getRows = (data) => {
      const rows = [];

      data.forEach((row, i) => {
      // Text/numeric values
      rows[i] = {
          value: row,
          label: row
        };
      });

      return rows;
  };

  return {
      parameter,
      getRows: getRows
  };
}
